import { addDays, formatLongDate, todayString } from '../util/date-bounds.js';
import styles from './DateNavigator.module.css';

interface DateNavigatorProps {
  value: string; // YYYY-MM-DD
  onChange: (next: string) => void;
}

export function DateNavigator({ value, onChange }: DateNavigatorProps) {
  const today = todayString();
  const isToday = value === today;
  const isFuture = value > today;
  return (
    <div className={styles.row}>
      <button
        type="button"
        className={styles.arrow}
        onClick={() => onChange(addDays(value, -1))}
        aria-label="Previous day"
      >
        &lsaquo;
      </button>
      <input
        type="date"
        value={value}
        max={today}
        onChange={(e) => onChange(e.target.value)}
        className={styles.date}
        aria-label="Selected date"
      />
      <button
        type="button"
        className={styles.arrow}
        onClick={() => onChange(addDays(value, 1))}
        disabled={isToday || isFuture}
        aria-label="Next day"
      >
        &rsaquo;
      </button>
      <span className={styles.label}>{formatLongDate(value)}</span>
      {!isToday && (
        <button type="button" className={styles.todayBtn} onClick={() => onChange(today)}>
          Today
        </button>
      )}
    </div>
  );
}
